<template>
  <div class="wrapper">
    <h3 v-if="title.length">{{ title }}</h3>
    <div class="context-menu-buttons-container">
      <div
        v-for="b in buttons"
        :key="b.title"
        class="context-menu-buttons-container__row"
        @click="() => emit(b.emit)"
      >
        <div class="button-icon">
          <img v-if="b.iconSrc" class="button-icon__image" :src="b.iconSrc" alt="button icon" />
          <template v-else-if="b.icon">
            <component :is="b.icon" />
          </template>
        </div>
        <div class="button-text">{{ b.title }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'

interface Button {
  title: string
  emit: string
  iconSrc?: string
  icon?: string
}

defineProps({
  title: {
    type: String,
    default: ''
  },
  buttons: {
    type: Array as PropType<Button[]>,
    default: () => [],
    validator: (values: Button[]) => values.every((b) => b.title && b.emit)
  }
})

const emit = defineEmits<(event: string, ...args: any[]) => void>()
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';

.button-icon {
  color: #3f46d6;
  &__image {
    height: 24px;
  }
}

.button-text {
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.wrapper {
  border-radius: 12px;
  border: 1px solid variables.$color-greyscale-secondary;
  overflow: hidden;
}

.context-menu-buttons-container {
  padding: variables.$padding-medium 0;
  color: variables.$color-greyscale-content;
  display: flex;
  min-width: 240px;
  flex-direction: column;
  align-items: flex-start;

  &__row {
    @include font-mixins.desktop-bold-label;
    padding: variables.$padding-medium variables.$padding-xlarge;
    height: 40px;
    display: flex;
    align-items: center;
    gap: variables.$margin-xlarge;
    align-self: stretch;

    &:hover {
      color: variables.$color-pure-white;
      background: variables.$color-primary;
      cursor: pointer;
      .button-icon {
        color: variables.$color-pure-white;
      }
    }
  }
}
</style>
